module.exports = __webpack_public_path__ + "img/1716360173976-WhatsApp Image 2024-05-22 at 14.36.28 1.jpeg.510b5b50.webp";